import { Grid, Typography, Divider } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import VisitorsReasonGrid from "./SubComponents/VisitorsReasonGrid";
import VisitorsRegionGrid from "./SubComponents/VisitorsRegionGrid";
import VisitorsCheckinFormConfig from "./SubComponents/VisitorsCheckinFormConfig";
import VisitorOrgType from "./OrgType/VisitorOrgType";
import {getUserData} from "../../Base/helper/baseFunctions";

const VisitorsConfiguration = () => {
  const theme = useTheme();
  const values = [
      { name: "Visit Reasons", comp: <VisitorsReasonGrid /> },
      { name: "Access Areas", comp: <VisitorsRegionGrid /> },
      ...(getUserData()?.core_hr_user_type === "Owner" ? [{ name: "Organization Type", comp: <VisitorOrgType /> }] : []),
      { name: "Visitors Configuration", comp: <VisitorsCheckinFormConfig /> },

  ];

  return (
    <Grid container spacing={2} style={{ padding: "10px 0px" }}>
      {values?.map((value, id) => (
        <React.Fragment key={id}>
          <Grid
            item
            xs={12}
            md={["Organization Type", "Visitors Configuration"].includes(value?.name) ? 12 : 6}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                paddingLeft: "15px",
                color: theme.palette.primary.contrastText,
              }}
            >
              {value.name}
            </Typography>
            {value?.comp}
          </Grid>
          {([1, 2, 3].includes(id)) && (
              <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
              </Grid>
          )}
        </React.Fragment>
      ))}

    </Grid>
  );
};

export default VisitorsConfiguration;
